module.exports = __webpack_public_path__ + "static/media/gluten.613bf5a3.png";